<template>
  <div>
    <base-header></base-header>
    <div class="container">
        <router-view></router-view>
    </div>
    <base-footer></base-footer>

  <div class="fixed-bottom pl-2 pb-2">
    <a href="https://www.producthunt.com/posts/propli?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-propli" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=289463&theme=light" alt="Propli - Online property management tool for smart landlords | Product Hunt" style="width: 250px; height: 54px;" width="250" height="54" /></a>
    </div>

    
  </div>
</template>

<script>
import baseHeader from '../layouts/partials/BaseHeader'
import baseFooter from '../layouts/partials/BaseFooter'


export default{
  components: {
    baseHeader,
    baseFooter
  }
}
</script>
